import { Table } from 'components/shared/Table';
import { useContactsAssignments } from 'modules/lenderDealerManagement/hooks';
import { ContactAssignmentTableEntity } from 'modules/lenderDealerManagement/types';
import { UserProfile } from 'types';

interface Props {
  contacts: UserProfile[];
  lenderProfileId: string;
}

export const ContactsAssignmentsTable = ({ contacts, lenderProfileId }: Props) => {
  const { isLoading, contactsAssignments, columns } = useContactsAssignments(contacts, lenderProfileId);

  return (
    <Table<ContactAssignmentTableEntity>
      columns={columns}
      tableData={contactsAssignments}
      paginationOptions={{
        pageSize: 4,
      }}
      tableProps={{
        showPaginationBottom: false,
      }}
    />
  );
};
